import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';


/*
    Addresses the issue where json content is not converted to Date type when deserialized
*/

export class InterceptorDateHttp implements HttpInterceptor {

  iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            const body = event.body;
            this.convertToDate(body);
          }
        },
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
            }
          }
        },
      }),
    );
  }

  protected convertToDate(body: any): void {
    if (typeof body === 'object' && body !== null) {
      this.traverseObject(body);
    }
  }

  protected traverseObject(obj: any): void {
    if (Array.isArray(obj)) {
      this.traverseArray(obj);
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (typeof value === 'object' && value !== null) {
            this.traverseObject(value);
          } else if (typeof value === 'string' && this.isIso8601(value)) {
            obj[key] = new Date(value);
          }
        }
      }
    }
  }

  protected traverseArray(arr: any[]): void {
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i];
      if (typeof item === 'object' && item !== null) {
        this.traverseObject(item);
      } else if (typeof item === 'string' && this.isIso8601(item)) {
        arr[i] = new Date(item);
      }
    }
  }

  protected isIso8601(value: unknown): value is string {
    return typeof value === 'string' && this.iso8601.test(value);
  }
}
